import React from 'react';

const ContactPage = () => {
  return (
    <div className="doc-page contact">
      <h1>お問合せ</h1>

      <p>ご質問・ご要望は以下のメールアドレスまでご連絡ください。</p>
      <p>メール: contact@garlic-hamster.com</p>

      <p>最終更新日：2026年1月1日</p>
    </div>
  );
};

export default ContactPage;
